module.exports = __webpack_public_path__ + "images/153_320.jpg";